export const EditorConstants = {
    atomFontFamily: "Roboto, Helvetica, Helvetica Neue, Arial",
    atomFontSize: "0.825em",
    Scale: 60,
};
